import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import authenticatedInstance from "../../redux/actions/AxiosInstance/authenticated";
import { toast } from "sonner";

const UpgradeLifetime = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      try {
        if (!token) {
          toast.error("Invalid lifetime upgrade link");
          navigate("/dashboard");
          return;
        }

        setLoading(true);
        await authenticatedInstance.post("/user/upgrade-lifetime", {
          lifetimeToken: token,
        });

        toast.success("Lifetime access unlocked!");
        navigate("/dashboard");
      } catch (error) {
        const message = error?.response?.data?.message || "Upgrade failed";
        toast.error(message);
        setTimeout(() => navigate("/dashboard"), 2000);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [token, navigate]);

  return (
    <div className="min-h-screen grid place-items-center font-Inter">
      {loading ? <p className="text-sm text-[#475467]">Upgrading...</p> : null}
    </div>
  );
};

export default UpgradeLifetime;

